import { iRequest } from '../../utils/requestutil';

export async function query(payload) {
  return iRequest(`/iwms-openapi/api/interfaceConfig/query`, {
    method: 'POST',
    body: payload,
  });
}

export async function save(payload) {
  return iRequest(`/iwms-openapi/api/interfaceConfig`, {
    method: 'POST',
    body: payload,
  });
}

export async function modify(payload) {
  return iRequest(`/iwms-openapi/api/interfaceConfig/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function offline(payload) {
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/offline?uuid=${payload.uuid}`,
    {
      method: 'POST',
    },
  );
}

export async function online(payload) {
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/online?uuid=${payload.uuid}`,
    {
      method: 'POST',
    },
  );
}

export async function suspend(payload) {
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/suspend?uuid=${payload.uuid}`,
    {
      method: 'POST',
    },
  );
}

export async function resume(payload) {
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/resume?uuid=${payload.uuid}`,
    {
      method: 'POST',
    },
  );
}

export async function debug(payload) {
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/debug?uuid=${payload.uuid}`,
    {
      method: 'POST',
    },
  );
}

export async function unDebug(payload) {
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/unDebug?uuid=${payload.uuid}`,
    {
      method: 'POST',
    },
  );
}

export async function copyDc(payload) {
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/copydc?companyUuid=${payload.companyUuid}&sourceDcCode=${payload.sourceDcCode}&dcCode=${payload.dcCode}&menuName=${payload.menuName}`,
    {
      method: 'POST',
    },
  );
}

export async function copyOwner(payload) {
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/copyowner?companyUuid=${payload.companyUuid}&sourceOwnerCode=${payload.sourceOwnerCode}&ownerCode=${payload.ownerCode}&menuName=${payload.menuName}`,
    {
      method: 'POST',
    },
  );
}

export async function exportInterface(payload) {
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/export?companyUuid=${payload.companyUuid}&ownerCode=${payload.ownerCode}&dcCode=${payload.dcCode}&interfaceUuid=${payload.interfaceUuid}&menuName=${payload.menuName}`,
    {
      method: 'POST',
    },
  );
}

export async function importInterface(payload) {
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/import?companyUuid=${payload.companyUuid}&ownerCode=${payload.ownerCode}&dcCode=${payload.dcCode}&erpUuid=${payload.erpUuid}&dingDingUuid=${payload.dingDingUuid}`,
    {
      method: 'POST',
      body: payload.jsonData,
    },
  );
}

export async function remove(payload) {
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/remove?uuid=${payload.uuid}`,
    {
      method: 'POST',
    },
  );
}

export async function queryDingding(payload) {
  return iRequest(
    `/iwms-account/account/dingding/query?companyUuid=${payload.companyUuid}&name=${payload.name}`,
  );
}

export async function isSupportFieldUpdate(payload) {
  return iRequest(
    `/iwms-openapi/api/interfaceConfig/isSupportFieldUpdate?interfaceName=${payload.interfaceName}`,
  );
}

export async function getEventTypes() {
  return iRequest(`/iwms-openapi/api/interfaceConfig/getEventTypes`);
}

export async function getAllInterfaceType() {
  return iRequest(`/iwms-openapi/api/interfaceConfig/getAllInterfaceType`);
}

export async function getAllMenuName() {
  return iRequest(`/iwms-openapi/api/interfaceConfig/getAllMenuName`);
}
